/** @jsxImportSource @emotion/react */
import { MouseEvent, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { useDetailsStore } from "@/stores/useDetailsStore";
import { useTableStoreByRoute } from "@/stores/useTableStore";

import { ViewColumnsIcon } from "@dotnet/telematics-design-system";

import { MenuAnchorEl, ROUTES } from "../../../../../shared";
import RectangleLoader from "../../../../../shared/components/loaders/RectangleLoader";
import Button from "../../../../Button/Button";
import Menu from "../../../../Menu/Menu";

import ColumnsToShow from "./ColumnsToShow";
import { useStyles } from "./styles";

interface TableViewProps {
  route: ROUTES;
}

const TableView = ({ route }: TableViewProps) => {
  const { initialLoading } = useTableStoreByRoute(route);

  const { resetDetailsSection } = useDetailsStore();

  const isInitialLoading = initialLoading || resetDetailsSection;
  const { t } = useTranslation();

  const { columnsToShowMenuCSS, tableViewButtonCSS, tableViewLoaderCSS } =
    useStyles();

  const [anchorEl, setAnchorEl] = useState<MenuAnchorEl>(null);

  const handleOpenMenu = (e: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleCloseMenu = () => setAnchorEl(null);

  return isInitialLoading ? (
    <RectangleLoader width={125} height={36} customStyle={tableViewLoaderCSS} />
  ) : (
    <>
      <Button
        color="white"
        size="small"
        variant="iconLeft"
        icon={<ViewColumnsIcon />}
        onClick={handleOpenMenu}
        css={css(tableViewButtonCSS)}
      >
        {t("Button##table view")}
      </Button>

      <Menu
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorEl={anchorEl}
        slotProps={{ list: { disableListWrap: true } }}
        css={css(columnsToShowMenuCSS)}
      >
        <ColumnsToShow route={route} />
      </Menu>
    </>
  );
};

export default TableView;
